import { useState, useRef, useEffect, FC } from "react";
import { Dropdown, FormControl } from "react-bootstrap";

interface SearchableDropdownProps {
    choices: string[] | undefined;
    selectedValue?: string;
    placeholder?: string;
    onSelect: (value: string) => void;
    variant?: string;
}

export const SearchableDropdown: FC<SearchableDropdownProps> = ({
    choices,
    selectedValue,
    placeholder,
    onSelect,
    variant
}) => {
    const [searchTerm, setSearchTerm] = useState<string>("");
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const searchInputRef = useRef<HTMLInputElement>(null);

    const filteredOptions = choices?.filter(choice =>
        choice.toLowerCase().includes(searchTerm.toLowerCase())
    );
    useEffect(() => {
        if (isOpen && searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [isOpen]);

    const handleSelect = (value: string) => {
        onSelect(value);
        setSearchTerm("");
        setIsOpen(false);
    };

    const handleToggle = (nextShow: boolean) => {
        setIsOpen(nextShow);
        if (!nextShow) {
            setSearchTerm("");
        }
    };

    return (
        <Dropdown show={isOpen} onToggle={handleToggle}>
            <Dropdown.Toggle
                style={{
                    minWidth: "150px",
                    textAlign: "start",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
                variant={variant}
            >
                {selectedValue || placeholder}
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ maxHeight: "430px", overflowY: "auto" }}>
                <div className="px-3 py-2" onClick={e => e.stopPropagation()}>
                    <FormControl
                        ref={searchInputRef}
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        size="sm"
                    />
                </div>
                <Dropdown.Divider />
                {filteredOptions && filteredOptions.length > 0 ? (
                    filteredOptions?.map(option => (
                        <Dropdown.Item
                            key={option}
                            onClick={() => handleSelect(option)}
                            active={selectedValue === option}
                        >
                            {option}
                        </Dropdown.Item>
                    ))
                ) : (
                    <Dropdown.Item disabled>No results found</Dropdown.Item>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};
